export default "__VITE_ASSET__C8c8t72D__"